export default "__VITE_ASSET__CDxKt7$e__"